import React from 'react'
import { View } from 'react-native'
// import { useHeaderHeight } from '@react-navigation/stack'

import tw from 'tailwind-rn'
import styles from './styles'
import { HGView } from '../../components/HGUI'
import OnboardingSlider from './OnboardingSlider'
import HansGretelLogo from '../auth/HansGretelLogo'

const OnboardingScreen = (): JSX.Element => {
  return (
    <HGView style={tw('pt-24 pb-12')}>
      <View style={[styles.logo, tw('items-center')]}>
        <HansGretelLogo />
      </View>

      <OnboardingSlider />
    </HGView>
  )
}

export default OnboardingScreen
